var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _ellipse, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _polygon, _path52, _polygon2, _path53, _path54, _path55, _path56, _circle, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b80fd712-d768-4ad0-b56e-a8f7496d51d1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 792.26546,
    height: 727.77798,
    viewBox: "0 0 792.26546 727.77798",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M566.75655,259.05824h-3.99878V149.51291A63.40187,63.40187,0,0,0,499.356,86.111H267.26925a63.40184,63.40184,0,0,0-63.402,63.4017V750.48713A63.40182,63.40182,0,0,0,267.26906,813.889H499.35567a63.40185,63.40185,0,0,0,63.402-63.40167V337.0345h3.99884Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M501.914,102.606H471.619a22.49485,22.49485,0,0,1-20.82715,30.99053H317.83242a22.49486,22.49486,0,0,1-20.82715-30.99061H268.70968a47.34781,47.34781,0,0,0-47.34784,47.34774V750.04628a47.34781,47.34781,0,0,0,47.34778,47.34784H501.914a47.34781,47.34781,0,0,0,47.34784-47.34778h0V149.95371A47.34777,47.34777,0,0,0,501.914,102.606Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M250.31185,385.03936a1,1,0,0,1-1-1v-35a1,1,0,0,1,2,0v35A1,1,0,0,1,250.31185,385.03936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M257.31185,390.53936a1,1,0,0,1-1-1v-46a1,1,0,0,1,2,0v46A1,1,0,0,1,257.31185,390.53936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M264.31185,394.03936a1,1,0,0,1-1-1v-53a1,1,0,0,1,2,0v53A1,1,0,0,1,264.31185,394.03936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M271.31185,403.03936a1,1,0,0,1-1-1v-71a1,1,0,0,1,2,0v71A1,1,0,0,1,271.31185,403.03936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M278.31185,416.53936a1,1,0,0,1-1-1v-98a1,1,0,0,1,2,0v98A1,1,0,0,1,278.31185,416.53936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M285.31185,403.03936a1,1,0,0,1-1-1v-71a1,1,0,0,1,2,0v71A1,1,0,0,1,285.31185,403.03936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M292.31185,409.53936a1,1,0,0,1-1-1v-84a1,1,0,0,1,2,0v84A1,1,0,0,1,292.31185,409.53936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M299.31185,392.53936a1,1,0,0,1-1-1v-50a1,1,0,0,1,2,0v50A1,1,0,0,1,299.31185,392.53936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M306.31185,396.53936a1,1,0,0,1-1-1v-58a1,1,0,0,1,2,0v58A1,1,0,0,1,306.31185,396.53936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M313.31185,385.03936a1,1,0,0,1-1-1v-35a1,1,0,0,1,2,0v35A1,1,0,0,1,313.31185,385.03936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M319.31185,385.03936a1,1,0,0,1-1-1v-35a1,1,0,0,1,2,0v35A1,1,0,0,1,319.31185,385.03936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M326.31185,390.53936a1,1,0,0,1-1-1v-46a1,1,0,0,1,2,0v46A1,1,0,0,1,326.31185,390.53936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M333.31185,394.03936a1,1,0,0,1-1-1v-53a1,1,0,0,1,2,0v53A1,1,0,0,1,333.31185,394.03936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M340.31185,403.03936a1,1,0,0,1-1-1v-71a1,1,0,0,1,2,0v71A1,1,0,0,1,340.31185,403.03936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M347.31185,432.53936a1,1,0,0,1-1-1v-130a1,1,0,0,1,2,0v130A1,1,0,0,1,347.31185,432.53936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M354.31185,403.03936a1,1,0,0,1-1-1v-71a1,1,0,0,1,2,0v71A1,1,0,0,1,354.31185,403.03936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M361.31185,409.53936a1,1,0,0,1-1-1v-84a1,1,0,0,1,2,0v84A1,1,0,0,1,361.31185,409.53936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M368.31185,392.53936a1,1,0,0,1-1-1v-50a1,1,0,0,1,2,0v50A1,1,0,0,1,368.31185,392.53936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M375.31185,396.53936a1,1,0,0,1-1-1v-58a1,1,0,0,1,2,0v58A1,1,0,0,1,375.31185,396.53936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M382.31185,385.03936a1,1,0,0,1-1-1v-35a1,1,0,0,1,2,0v35A1,1,0,0,1,382.31185,385.03936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M388.31185,385.03936a1,1,0,0,1-1-1v-35a1,1,0,0,1,2,0v35A1,1,0,0,1,388.31185,385.03936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M395.31185,390.53936a1,1,0,0,1-1-1v-46a1,1,0,0,1,2,0v46A1,1,0,0,1,395.31185,390.53936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M402.31185,394.03936a1,1,0,0,1-1-1v-53a1,1,0,0,1,2,0v53A1,1,0,0,1,402.31185,394.03936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M409.31185,403.03936a1,1,0,0,1-1-1v-71a1,1,0,0,1,2,0v71A1,1,0,0,1,409.31185,403.03936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M416.31185,416.53936a1,1,0,0,1-1-1v-98a1,1,0,0,1,2,0v98A1,1,0,0,1,416.31185,416.53936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M421.31185,460.78936a1,1,0,0,1-1-1v-186.5a1,1,0,0,1,2,0v186.5A1,1,0,0,1,421.31185,460.78936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ff9100"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M423.31185,403.03936a1,1,0,0,1-1-1v-71a1,1,0,0,1,2,0v71A1,1,0,0,1,423.31185,403.03936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M430.31185,409.53936a1,1,0,0,1-1-1v-84a1,1,0,0,1,2,0v84A1,1,0,0,1,430.31185,409.53936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M437.31185,392.53936a1,1,0,0,1-1-1v-50a1,1,0,0,1,2,0v50A1,1,0,0,1,437.31185,392.53936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M444.31185,396.53936a1,1,0,0,1-1-1v-58a1,1,0,0,1,2,0v58A1,1,0,0,1,444.31185,396.53936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M451.31185,385.03936a1,1,0,0,1-1-1v-35a1,1,0,0,1,2,0v35A1,1,0,0,1,451.31185,385.03936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M457.31185,385.03936a1,1,0,0,1-1-1v-35a1,1,0,0,1,2,0v35A1,1,0,0,1,457.31185,385.03936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M464.31185,390.53936a1,1,0,0,1-1-1v-46a1,1,0,0,1,2,0v46A1,1,0,0,1,464.31185,390.53936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M471.31185,394.03936a1,1,0,0,1-1-1v-53a1,1,0,0,1,2,0v53A1,1,0,0,1,471.31185,394.03936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M478.31185,403.03936a1,1,0,0,1-1-1v-71a1,1,0,0,1,2,0v71A1,1,0,0,1,478.31185,403.03936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M485.31185,432.53936a1,1,0,0,1-1-1v-130a1,1,0,0,1,2,0v130A1,1,0,0,1,485.31185,432.53936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M492.31185,403.03936a1,1,0,0,1-1-1v-71a1,1,0,0,1,2,0v71A1,1,0,0,1,492.31185,403.03936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M499.31185,409.53936a1,1,0,0,1-1-1v-84a1,1,0,0,1,2,0v84A1,1,0,0,1,499.31185,409.53936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M506.31185,392.53936a1,1,0,0,1-1-1v-50a1,1,0,0,1,2,0v50A1,1,0,0,1,506.31185,392.53936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M513.31185,396.53936a1,1,0,0,1-1-1v-58a1,1,0,0,1,2,0v58A1,1,0,0,1,513.31185,396.53936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M520.31185,385.03936a1,1,0,0,1-1-1v-35a1,1,0,0,1,2,0v35A1,1,0,0,1,520.31185,385.03936Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M278.31184,626.5616v35.7l28-17.85Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#3f3d56"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 383.31188,
    cy: 644.40154,
    rx: 19.96034,
    ry: 20.03154,
    transform: "translate(-547.17264 373.33456) rotate(-44.97337)",
    fill: "#ff9100"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M470.60184,660.40157h-6.85a3.43,3.43,0,0,1-3.43-3.42v-25.14a3.44,3.44,0,0,1,3.43-3.43h6.85a3.43,3.43,0,0,1,3.43,3.43v25.15A3.42,3.42,0,0,1,470.60184,660.40157Zm21.71-3.41v-25.15a3.43,3.43,0,0,0-3.42-3.43h-6.86a3.44,3.44,0,0,0-3.43,3.43v25.15a3.43,3.43,0,0,0,3.43,3.42h6.86A3.42,3.42,0,0,0,492.31187,656.99159Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#3f3d56"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M472.95886,487.55288h-175.294a1.19069,1.19069,0,0,1,0-2.38137h175.294a1.19068,1.19068,0,0,1,0,2.38137Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M472.95886,247.55288h-175.294a1.19069,1.19069,0,0,1,0-2.38137h175.294a1.19069,1.19069,0,0,1,0,2.38137Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ccc"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M756.4977,403.58282a2.8188,2.8188,0,0,1-.36621-.02393l-34.19336-4.48925a2.82648,2.82648,0,0,1-1.79639-4.61426L743.976,366.05206a2.82147,2.82147,0,0,1,4.86719.957l10.3479,32.89453a2.8271,2.8271,0,0,1-2.69336,3.6792Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#f2f2f2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M692.45619,557.52813a2.82634,2.82634,0,0,1-2.82495-2.78711l-.44116-37.07519a2.82184,2.82184,0,0,1,4.31445-2.44776l29.29053,18.19971a2.82707,2.82707,0,0,1,.063,4.7666l-28.85669,18.88526a2.82,2.82,0,0,1-1.50439.45849Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#f2f2f2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M964.45619,614.52813a2.82634,2.82634,0,0,1-2.82495-2.78711l-.44116-37.07519a2.82184,2.82184,0,0,1,4.31445-2.44776l29.29053,18.19971a2.82707,2.82707,0,0,1,.063,4.7666l-28.85669,18.88526a2.82,2.82,0,0,1-1.50439.45849Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#f2f2f2"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M822.05675,489.76018c-8.10949-3.7255-13.44023-14.37685-13.13662-24.88137s5.83147-20.32877,13.45571-25.33817a26.6494,26.6494,0,0,1,25.21942-1.90564c8.18252,3.483,19.16872,4.43181,24.087,13.089,3.77959,6.65281,2.41808,21.49465-.25791,28.89228-2.31293,6.394-7.96837,9.99663-13.48333,12.0127a45.34009,45.34009,0,0,1-37.51095-3.0216",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "707.894 697.404 696.404 701.68 674.442 659.397 691.399 653.086 707.894 697.404",
    fill: "#ffb8b8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M893.16389,785.56807h23.64387a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H878.277a0,0,0,0,1,0,0v0A14.88685,14.88685,0,0,1,893.16389,785.56807Z",
    transform: "translate(-424.10622 276.76743) rotate(-20.41457)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "597.676 709.212 585.416 709.212 579.584 661.924 597.678 661.924 597.676 709.212",
    fill: "#ffb8b8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M576.65931,705.70864h23.64387a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H561.77246a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,576.65931,705.70864Z",
    fill: "#2f2e41"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M764.26671,624.86876a10.74268,10.74268,0,0,0,9.16586-13.687L813.76063,541.609l-14.10511-5.6406-40.31356,68.022a10.80091,10.80091,0,0,0,4.92475,20.87831Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ffb8b8"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M804.70229,566.34161l-21.43335-13.31738,20.21094-36.82862a13.824,13.824,0,1,1,23.8396,13.981Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#2f2e41"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M886.5392,763.23614a4.48111,4.48111,0,0,1-4.0061-2.477l-53.32105-109.7544a3.5,3.5,0,0,0-6.54809.86768l-18.99634,104.606a4.522,4.522,0,0,1-4.40772,3.59326H787.15859a4.47841,4.47841,0,0,1-4.48267-4.08984c-7.43506-81.585-3.41186-140.95459,11.95825-176.459a4.525,4.525,0,0,1,5.29907-2.54932L861.3727,593.4793a4.50463,4.50463,0,0,1,3.19653,3.24805l38.5083,157.07031a4.50425,4.50425,0,0,1-3.00976,5.38575l-12.16138,3.84033A4.52677,4.52677,0,0,1,886.5392,763.23614Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 634.94727,
    cy: 389.04742,
    r: 24.56103,
    fill: "#ffb8b8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M862.01139,511.07182s-22-12-39,1c0,0-21.5,21.5-14.5,42.5l-17.5,49.5c13.84717,26.256,54.38476,22.00519,74,0l-1.5-47.5Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ff9100"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M875.9374,643.29717a23.21681,23.21681,0,0,1-11.04078-2.45458c-5.40136-2.89795-8.72558-8.34815-9.87988-16.19825-1.92822-13.1123-.33984-31.13672,1.342-50.21924,2.1875-24.81787,4.44922-50.48046-1.60669-64.603a4.49111,4.49111,0,0,1,4.90552-6.18067l17.22559,2.96973a4.52537,4.52537,0,0,1,3.65039,3.56543l23.87915,121.30615a4.48772,4.48772,0,0,1-2.48926,4.937C896.72255,638.868,885.92665,643.29717,875.9374,643.29717Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#2f2e41"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M785.73964,641.68438a4.52465,4.52465,0,0,1-1.79565-.37256c-2.834-1.22509-6.75171-3.0039-11.644-5.28711-13.51342-6.30615,22.12549-93.42773,29.407-110.82812a4.45276,4.45276,0,0,1,1.12133-1.58887l19.50879-17.75586a4.49873,4.49873,0,0,1,7.07642,4.833c-3.4231,11.47314-9.48706,30.70654-15.90723,51.06885-10.13159,32.13525-20.6084,65.36474-23.40893,76.53271a4.49241,4.49241,0,0,1-4.35767,3.398Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#2f2e41"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M922.85969,620.61246a10.74274,10.74274,0,0,0-5.4016-15.56182L886.2277,530.94681l-13.00012,7.85924,30.00148,73.158a10.80091,10.80091,0,0,0,19.63063,8.64844Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#ffb8b8"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M876.96767,562.16094l-17.217-38.31982a13.82422,13.82422,0,1,1,25.522-10.604l15.23706,39.84082Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#2f2e41"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M856.27693,444.58752a4.06328,4.06328,0,0,0,4.31681-2.40945,5.85068,5.85068,0,0,0-.41557-5.13768,10.73569,10.73569,0,0,0-3.7759-3.70338,12.406,12.406,0,0,0-5.98158-2.05789,7.46122,7.46122,0,0,0-5.79386,2.19927,5.37673,5.37673,0,0,0-.97171,5.92757c.89811,1.73189,2.78252,2.70308,4.61861,3.36249a27.09442,27.09442,0,0,0,11.37778,1.49441",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#2f2e41"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M865.01139,471.07182c-3.827,1.11454-3.61863-.94778-5.7169-4.33684s-4.82607-7.3773-8.80645-7.165c-3.262.17394-5.53377,3.13712-7.85885,5.4316-4.14412,4.08956-10.15988,6.67913-15.8467,5.43076s-10.37564-7.11523-9.12618-12.80181a11.94249,11.94249,0,0,1,5.88027-7.46677,24.02835,24.02835,0,0,1,9.32469-2.726,49.64692,49.64692,0,0,1,21.41981,2.24043c4.75583,1.59573,9.53714,4.17684,11.90414,8.59969s4.43914,10.823-.17383,12.794Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#2f2e41"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M852.899,431.91847c-3.2427-4.11085-2.02127-10.58761,1.75819-14.21113s9.39951-4.75287,14.615-4.292a29.6206,29.6206,0,0,1,24.02454,17.27486c3.29591,7.53929,3.2687,16.16291,6.24936,23.83231a32.13673,32.13673,0,0,0,43.41,17.54257c5.18809-2.39208,10.12829-7.07632,9.83209-12.78163,3.28017,12.64629-2.62756,27.11236-13.82269,33.84715-6.55732,3.94476-14.32314,5.284-21.91988,6.20555-4.95073.60059-10.03889,1.04741-14.87-.18987-6.75916-1.731-12.4182-6.71982-15.84495-12.79766s-4.77477-13.16056-4.827-20.13767c-.04071-5.4353.67085-10.87348.29483-16.29592s-2.00606-11.03112-5.93667-14.78538-10.5637-4.98991-14.87754-1.6831c-1.73367,1.329-3.00428,3.26972-4.95633,4.25017s-5.036.21793-5.16664-1.96259Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#2f2e41"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M984.16386,808.14343h-307.294a1.19069,1.19069,0,0,1,0-2.38137h307.294a1.19069,1.19069,0,0,1,0,2.38137Z",
    transform: "translate(-203.86727 -86.11101)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecords);
export default __webpack_public_path__ + "static/media/records.4fff148f0176ce81f3e515d8f7f5b631.svg";
export { ForwardRef as ReactComponent };